function isInViewport(element) {
  if (
      !element || 
      element.style.display == 'none' ||
      element.style.visibility == 'hidden'
  ) {
      console.log('hidden')
      return false;
  }
      
  var rect = element.getBoundingClientRect();

  if (rect.width <= 0 || rect.height <= 0) return false;

  let screenHeight = window.innerHeight || document.documentElement.clientHeight;
  let screenWidth = window.innerWidth || document.documentElement.clientWidth;

  if (
      rect.bottom <= 0 ||
      rect.top >= screenHeight ||
      rect.left >= screenWidth ||
      rect.right <= 0
  ) return false;

  return true;
}

export { isInViewport };